import {Fragment} from "react";
import BasicModal from "../../../../../../../common/BasicModal";
import PositiveFeedbackModalContainer from "./PositiveFeedbackModalContainer";

export default function PositiveFeedbackModal({title, open, handleClose}) {

    const Content = () => {
        return (
            <PositiveFeedbackModalContainer
                handleClose={handleClose}
            />
        )
    }

    return(
        <Fragment>
            <BasicModal
                title={title}
                open={open}
                style={{width: '500px'}}
                handleClose={handleClose}>

                <Content />
            </BasicModal>
        </Fragment>
    )
}